export default __webpack_public_path__ + "static/media/banner-left-bg.1387d49d.png";